import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ 
  rating = 0, 
  maxStars = 5, 
  size = 24, 
  interactive = false, 
  onRatingChange = () => {},
  showValue = false 
}) => {
  const [hoverRating, setHoverRating] = React.useState(0);

  const handleClick = (index) => {
    if (interactive) {
      onRatingChange(index);
    }
  };

  const handleMouseEnter = (index) => {
    if (interactive) {
      setHoverRating(index);
    }
  };

  const handleMouseLeave = () => {
    if (interactive) {
      setHoverRating(0);
    }
  };

  const displayRating = hoverRating || rating;

  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      <div className="star-rating">
        {[...Array(maxStars)].map((_, index) => {
          const starValue = index + 1;
          const isFilled = starValue <= displayRating;
          
          return (
            <button
              key={index}
              type="button"
              className={`star ${isFilled ? 'star-filled' : 'star-empty'} ${interactive ? 'cursor-pointer' : 'cursor-default'}`}
              onClick={() => handleClick(starValue)}
              onMouseEnter={() => handleMouseEnter(starValue)}
              onMouseLeave={handleMouseLeave}
              disabled={!interactive}
              data-testid={`star-${starValue}`}
              aria-label={`${starValue} étoile${starValue > 1 ? 's' : ''}`}
            >
              <Star 
                size={size} 
                fill={isFilled ? "#FFB703" : "none"}
                strokeWidth={2}
              />
            </button>
          );
        })}
      </div>
      {showValue && (
        <span className="ml-2 text-sm font-bold text-slate-700">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
};

export const StarDisplay = ({ rating, size = 20, showValue = true }) => {
  return (
    <div className="flex items-center gap-2" data-testid="star-display">
      <div className="flex">
        {[...Array(5)].map((_, index) => (
          <Star 
            key={index}
            size={size} 
            fill={index < Math.round(rating) ? "#FFB703" : "none"}
            stroke={index < Math.round(rating) ? "#FFB703" : "#E2E8F0"}
            strokeWidth={2}
          />
        ))}
      </div>
      {showValue && (
        <span className="text-sm font-bold">{rating.toFixed(1)}</span>
      )}
    </div>
  );
};
